<div class="srIrops-itinerary" style="gap: 60px; margin-top: 30px;">
  <div class="srIrops-newItinerary">
    <div class="srIrops-textNewItinerary text-am-white fs-24px fw-regular lh-30px mb-2">
      <span>
        {{ "srIrops.newItinerary" | translate }}
      </span>
    </div>
    <div class="srIrops-tagTimeChangeSmall text-am-blue fs-14px" *ngIf="itinerary == 2"> 
      <span *ngIf="firstAfectedTime?.status == 'DELAYED'">
        + <span *ngIf="firstAfectedTime?.hours > 0">{{ firstAfectedTime?.hours }}h</span> {{ firstAfectedTime?.minutes }}m
      </span>
    </div>
    <div class="srIrops-tagTimeChangeLarge" *ngIf="[3,4,5].includes(itinerary)">
      <div class="text-am-blue fs-14px" *ngIf="itinerary == 3">
        {{ "srIrops.changeIn" | translate }} <b>{{ segModify?.length }} {{ "srIrops.connectingFlights" | translate }}</b>
      </div>
      <div class="text-am-blue fs-14px" *ngIf="itinerary == 4">
        {{ "srIrops.changeIn" | translate }} <b>{{ firstAfected?.departureAirport }}-{{ firstAfected?.arrivalAirport }}</b>
      </div>
      <div class="text-am-blue fs-14px" *ngIf="itinerary == 5"> 
        <span *ngIf="firstAfectedTime?.status == 'AHEAD'">
          {{ "srIrops.broughtAhead" | translate }} <span *ngIf="firstAfectedTime?.hours > 0">{{ firstAfectedTime?.hours }}h</span> {{ firstAfectedTime?.minutes }}m
        </span>
      </div>
    </div>
  </div>
  <div class="srIrops-separatorLine" style="height: 100px;"></div>
  <div class="srIrops-routeOriginDestination">
    <div class="srIrops-origin">
      <span class="srIrops-originDate text-am-white fs-24px fw-regular lh-34px">
        {{ dateDeparture | localizedDate:'dd MMM' | titlecase }}
      </span>
      <div class="srIrops-originHour">
        <div class="text-am-yellow fs-32px fw-medium-x lh-42px"
          [ngClass]="{ 'srIrops-textNotAffected': !isAfectedFirstSeg }">
          <span>
            {{ timeItinerary.departureTime }}
          </span>
        </div>
      </div>
      <div class="srIrops-originDeparture text-am-white fs-24px fw-regular lh-34px">
        <span> 
          {{ firstSegment?.departureAirport }}
        </span>
      </div>
    </div>
    <div class="srIrops-lineRoute">
      <div class="srIrops-pointOrigin"
        [ngClass]="{ 'srIrops-isNotAffected': !isAfectedFirstSeg }">
      </div>
      <div class="srIrops-lineOne" [ngClass]="{ 'srIrops-isNotAffected': !isAfectedFirstSeg }">
      </div>

      <div class="srIrops-pointConnecting" *ngIf="[3,4].includes(lineRoute)">
        {{ segments?.length - 1 }}
      </div>

      <div class="srIrops-textOneConnecting" *ngIf="lineRoute == 3">
        <div class="fs-22px text-am-white">
          {{ firstSegment?.arrivalAirport }}
        </div>
        <div class="fs-22px text-am-yellow" *ngIf="timeConnecting.hours > 0 || timeConnecting.minutes > 0">
          <span *ngIf="timeConnecting.hours > 0">{{ timeConnecting.hours }}h</span> {{ timeConnecting.minutes }}m
        </div>
      </div>

      <div class="srIrops-textTwoConnecting" *ngIf="lineRoute == 4">
          <div class="fs-22px text-am-white" *ngFor="let scale of scales; let i = index;">
              <span [ngClass]="{ 'fs-22px text-am-yellow': scale.isAffected }">
                  {{ scale.iataDeparture }}
                  <span class="srIrops-comma text-am-white" *ngIf="i < (scales.length - 1)">
                  , 
                  </span>
              </span>
          </div>
      </div>

      <div class="srIrops-lineTwo" [ngClass]="{ 'srIrops-isNotAffected': !isAfectedLastSeg }">
      </div>
      <div class="srIrops-pointDestination"
        [ngClass]="{ 'srIrops-isNotAffected': !isAfectedLastSeg }">
      </div>
    </div>
    <div class="srIrops-destination">
      <span class="srIrops-destinationDate text-am-white fs-24px fw-regular lh-34px">
        {{ dateArrival | localizedDate:'dd MMM' | titlecase }}
      </span>
      <div class="srIrops-destinationHour text-am-yellow fs-32px fw-medium-x lh-42px"
        [ngClass]="{ 'srIrops-textNotAffected': !isAfectedLastSeg }">
        <span>
          {{ timeItinerary.arrivalTime }}
        </span>
      </div>
      <div class="srIrops-destinationDeparture text-am-white fs-24px fw-regular lh-34px">
        <span>
          {{ lastSegment?.arrivalAirport }}
        </span>
      </div>
    </div>
  </div>
</div>
<app-banner-irops-view 
 copyButtonBanner="srIrops.IropsBannerButton"
 [copyTextMain]="changeCopyBanner"
 [showButtonChangeFlight]="true">
</app-banner-irops-view>